import { useState ,useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { V4_COMPANY } from "../data/siteV4";
import MagneticButton from "../components/anim/MagneticButton";
import { Menu, X, ArrowUpRight } from "lucide-react";



const nav = [
  { label: "About",        href: "#about" },
  { label: "Clients",      href: "#clients" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Products",     href: "#products" },
  { label: "Industries",   href: "#industries" },
  { label: "Careers",      href: "#careers" },
  { label: "Contact",      href: "#contact" },
];
const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header data-testid="v4-header" className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "bg-white/90 backdrop-blur-xl border-b border-slate-200 shadow-sm" : "bg-white/60 backdrop-blur-sm"}`}>
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-24 md:h-28 flex items-center justify-between gap-6">
        <Link to="/" data-testid="v4-logo" className="flex items-center gap-3 shrink-0">
          <img src={V4_COMPANY.logoColor} alt="Nikhan Controls" className="h-16 md:h-20 w-auto object-contain" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {nav.map((n) => (
            <a key={n.href} href={n.href} data-testid={`v4-nav-${n.label.toLowerCase()}`} className="px-3 py-2 text-[13px] font-semibold tracking-tight text-navy-800 hover:text-amber-600 transition-colors">
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <MagneticButton strength={0.35}>
            <a href="#contact" data-testid="v4-cta-quote" className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-navy-800 hover:bg-navy-700 text-white font-semibold text-sm tracking-tight transition-all group">
              Start a Conversation
              <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
            </a>
          </MagneticButton>
          <button data-testid="v4-mobile-toggle" onClick={() => setOpen((v) => !v)} className="lg:hidden w-11 h-11 rounded-full border border-slate-200 bg-white flex items-center justify-center text-navy-800 shadow-sm" aria-label="Toggle menu">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }} className="lg:hidden bg-white border-t border-slate-200 overflow-hidden">
            <nav className="max-w-7xl mx-auto px-5 py-5 flex flex-col gap-1">
              {nav.map((n) => (
               <a
  key={n.href}
  href={n.href}
  onClick={(e) => {
    e.preventDefault();

    const id = n.href.replace("#", "");
    const element = document.getElementById(id);

    setOpen(false);

    setTimeout(() => {
      element?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      window.history.pushState(null, "", n.href);
    }, 250);
  }}
  className="px-4 py-3 rounded-lg text-base font-semibold text-navy-800 hover:bg-slate-50"
>
  {n.label}
</a>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
export default Header;
